import {
  BreadcrumbCurrentLink,
  BreadcrumbRoot,
} from "@/components/ui/breadcrumb";
import { useLangRouter } from "@/utils/use-lang-router";
import { Button } from "@chakra-ui/react";

export const Breadcrumb = ({
  items,
  current,
}: {
  items: { label: string; href: string }[];
  current: string;
}) => {
  const { push } = useLangRouter();
  return (
    <BreadcrumbRoot alignContent="center" flex={1} w="full" overflow="hidden">
      {items.map((item) => (
        <Button
          key={item.href}
          variant="plain"
          px={2}
          onClick={() => push(item.href)}
        >
          {item.label}
        </Button>
      ))}
      <BreadcrumbCurrentLink truncate>{current}</BreadcrumbCurrentLink>
    </BreadcrumbRoot>
  );
};
